export let FeedbackListSort = /*#__PURE__*/function (FeedbackListSort) {
  FeedbackListSort["SOLVED_AT"] = "solvedAt";
  return FeedbackListSort;
}({});
export let FeedbackListFilter = /*#__PURE__*/function (FeedbackListFilter) {
  FeedbackListFilter["IS_CHECK"] = "isCheck";
  FeedbackListFilter["MATERIAL_COURSE"] = "materialCourse";
  FeedbackListFilter["MATERIAL_TYPE"] = "materialType";
  return FeedbackListFilter;
}({});
export const FeedbackListColumn = {
  MISSION_TITLE: 'missionTitle',
  PROBLEM_NUMBER: 'problemNumber',
  IS_CHECK: FeedbackListFilter.IS_CHECK,
  MATERIAL_COURSE: FeedbackListFilter.MATERIAL_COURSE,
  MATERIAL_TYPE: FeedbackListFilter.MATERIAL_TYPE,
  SOLVED_AT: FeedbackListSort.SOLVED_AT
};